interface IvalidatorRule {
    fn: Function;
    options: any;
}

export enum EvalidatorRequire {
    Require  = 0,
    Optional = 1
}

export class ValidatorService {

    private list: any = [];

    constructor() {

    }

    public addField(value: any, name: string, require: EvalidatorRequire, rules: IvalidatorRule[]): ValidatorService {
        this.list.push({value: value, name: name, require: require, rules: rules});
        return this;
    }

    public run(): any {
        let errors       = [];
        let err: boolean = false;

        this.list.forEach((field: any)=> {
            //optional
            if (field.require == 1 && this.require(field.value)) {
                return;
            }
            field.rules.forEach((rule: IvalidatorRule)=> {
                let error = rule.fn(field.value, rule.options);
                if (error) {
                    if (!errors[field.name])
                        errors[field.name] = [];
                    errors[field.name].push(error);
                    err = true;
                }
            });
        });

        if (err)
            return errors;
        return null;
    }

    private require(value: any): boolean {
        return (value == undefined || value == null || value == '');
    }

    public stringLength(value: any, _options: any): any {
        if (!value || value.length < _options.min || value.length > _options.max)
            return {'description': 'Longeur entre ' + _options.min + ' et ' + _options.max};
        return false;
    }

    public file(value: any, _options: any): any {
        if (!value)
            return {'description': 'Fichier vide'};
        if (_options.size && value.size > _options.size)
            return {'description': 'Fichier trop grand'};
        if (_options.type && value.type > _options.type)
            return {'description': 'Format inconnu'};
        return false;
    }

    public requireOnce(value: any, _option: any): any {
        if (value == '' && _option.fieldB == '')
            return {'description' : 'Un des champs ' + _option.description + ' est requis'};
        return false;
    }

    public phoneNumber(value: any, _option: any): any {
        let tmp = value.toString();
        tmp = tmp.replace(/\s/g, '');
        if (!tmp.match(/^[0]{1}[0-9]{12}$/g) && !tmp.match(/^0[0-9]{9}$/g))
            return {'description' : 'N\'est pas un téléphone valide'};
        return false;
    };

    public bike(value: any, _option: any): any {
        if (!value.brand || !value.model || value.brand.length < 2 || value.model.length < 2)
            return {'description' : 'le vélo n\'est pas valide'};
        if (value.comment && (value.comment.length < 2 || value.comment.length > 42))
            return {'description' : 'le vélo n\'est pas valide'};
        if (value.numCad && (value.numCad.length < 2 || value.numCad.length > 42))
            return {'description' : 'le vélo n\'est pas valide'};
        if (value.size && (value.size.length < 2 || value.size.length > 42))
            return {'description' : 'le vélo n\'est pas valide'};
        return false;
    };

    public mail(value: any, _option: any): any {
        if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/g))
            return {'description' : 'N\'est pas un email valide'};
        return false;
    };

    public date(value: any, _option: any): any {
        if (!(value instanceof Date))
            return {'description' : 'N\'est pas une date'};
        return false;
    };


    public integer(value: any, _option: any):any {
        if (!(Number.isInteger(value) && value >= _option.min && value <= _option.max))
            return {'description' : 'Entre ' + _option.min + ' et ' + _option.max };
        return false;
    }

    public double(value: any, _option: any):any {
        if (!(Number.isFinite(value) && value >= _option.min && value <= _option.max))
            return {'description' : 'Entre ' + _option.min + ' et ' + _option.max };
        return false;
    }

    public boolean(value: any, _option: any):any {
        if (!(value === true || value === false))
            return {'description' : 'N\'est pas un boolean '};
        return false;
    }

    public listWork(value:any, _option:any):any{
        for(let i = 0; i < value.length; i++){
            if (value[i].title) {
                if (value[i].title.length < 2 || value[i].title.length > 42)
                    return {description: 'title', row: i};
                if (value[i].price && !(Number.isFinite(value[i].price)))
                    return {description: 'price', row: i};
                if (value[i].quantity && !(Number.isInteger(value[i].quantity)))
                    return {description: 'quantity', row: i};
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/validator.service.ts